import React from 'react';
import { AppBar, Toolbar, Typography} from "@material-ui/core";
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import { makeStyles } from "@material-ui/styles"
import Box from '@material-ui/core/Box';


const useStyles = makeStyles(()=>({
  typographyStyles:{
    flex : 1
  }
}));

const Header = () => {
  const classes = useStyles()
  return(
    <AppBar position="static">
      <Toolbar >
        <Typography className={classes.typographyStyles}>
          <Box fontWeight = "fontWeightBold" fontSize={30}>
            KDCA COVID-19 Nomogram
          </Box>
          <Box fontWeight = "fontWeightBold" fontSize={17}>
             Prediction patient's condition will become severe or critical
          </Box>
        </Typography>
        <LocalHospitalIcon fontSize="large"/>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
